import {Component, Inject, OnInit} from "@angular/core";
import {MatDialogRef, MAT_DIALOG_DATA} from "@angular/material/dialog";
import {CompanyService} from "../../services/company-service/company-service";
import {CategoryService} from "../../services/category/category.service";
import {IntakeFieldVM} from "../../models/IntakeForm.model";
import {CompanyCustomerFormDataVM} from "../../models/CompanyCustomerFormDataVM.model";

@Component({
  selector: 'rw-company-custom-form-dialog',
  template: require('./companyCustomForm-dialog.component.html'),
  styles: [require('./companyCustomForm-dialog.style.css')]
})
export class CompanyCustomFormDialogComponent implements OnInit {
  fieldObject: any;
  companyCustomerFormData: CompanyCustomerFormDataVM;

  constructor(private companyService: CompanyService,
              private categoryService: CategoryService,
              public dialogRef: MatDialogRef<CompanyCustomFormDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.companyCustomerFormData = new CompanyCustomerFormDataVM();
  }

  ngOnInit() {
    this.fieldObject = this.data.fieldsObj.fields;
    this.fieldObject.forEach(el => {
      if (el.field.selectorDataTypeId) {
        this.categoryService.getSelectorDataByTypeId(el.field.selectorDataTypeId).subscribe(function (opts) {
          el.field.options = opts;
        });
      }
    })

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  confirm() {
    this.fieldObject.id = this.data.id;
    ;
    this.companyCustomerFormData;
    this.companyCustomerFormData.intakeDataDTO = {
      fields: this.fieldObject,
      intakeParentType: "COMPANY_CUSTOMER"
    };
    this.dialogRef.close(this.companyCustomerFormData);
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/company-custom-form/companyCustomForm-dialog.component.ts